

function addPlugins(config, slot_name, plugins) {
  if (slot_name in config.pluginSlots === false) {
    config.pluginSlots[slot_name] = {
      keepDefault: true,
      plugins: []
    };
  }

  config.pluginSlots[slot_name].plugins.push(...plugins);
}

async function setConfig () {
  let config = {
    pluginSlots: {}
  };

  try {
    /* We can't assume FPF exists, as it's not declared as a dependency in all
     * MFEs, so we import it dynamically. In addition, for dynamic imports to
     * work with Webpack all of the code that actually uses the imported module
     * needs to be inside the `try{}` block.
     */
    const { DIRECT_PLUGIN, PLUGIN_OPERATIONS } = await import('@openedx/frontend-plugin-framework');
    addPlugins(config, 'footer_slot', [
        {
          op: PLUGIN_OPERATIONS.Hide,
          widgetId: 'default_contents',
        }]);
    addPlugins(config, 'footer_slot', [
        {
          op: PLUGIN_OPERATIONS.Insert,
          widget: {
            id: 'custom_footer',
            type: DIRECT_PLUGIN,
            RenderWidget: () => (
              <div className="wrapper wrapper-footer">
                <footer id="footer-openedx" className="grid-container">
                    <div className="footer-top">
                    <div className="footer-block">
                        <div className="inter-big">
                        <p>Universidad Metropolitana de Ciencias de la Educación</p>
                        </div>
                        <div className="inter-sm">
                        <p>Casa Central: Av. José Pedro Alessandri 774, Ñuñoa, Santiago - Chile</p>
                        </div>
                        <div className="inter-sm">
                        <p><a href="mailto:contacto@umce.cl" className="mailto-link">contacto@umce.cl</a></p>
                        </div>
                    </div>
                    <div className="footer-block">
                        <div className="inter-big">
                        <p>Unidad de desarrollo y formación virtual</p>
                        </div>
                        <div className="inter-sm">
                        <p><span>UDFV - </span>
                        <a href="mailto:udf@umce.cl">
                         udf@umce.cl
                        </a>
                        </p>
                        </div>
                    </div>
                    </div>
                    <div className="footer-separator"></div>
                    <div className="footer-bottom">
                    <a href="/privacy">Privacidad y Términos de uso</a>
                    <p>| Copyrights ©2025. Todos los derechos reservados</p>
                    </div>
                </footer>
            </div>
            ),
          },
        }]);
    if (process.env.APP_ID == 'authn') {
    }
    if (process.env.APP_ID == 'authoring') {
    }
    if (process.env.APP_ID == 'account') {
    }
    if (process.env.APP_ID == 'communications') {
    }
    if (process.env.APP_ID == 'discussions') {
    }
    if (process.env.APP_ID == 'gradebook') {
    }
    if (process.env.APP_ID == 'learner-dashboard') {
    }
    if (process.env.APP_ID == 'learning') {
    }
    if (process.env.APP_ID == 'ora-grading') {
    }
    if (process.env.APP_ID == 'profile') {
    }
  } catch { }

  return config;
}

export default setConfig;